import { z } from "zod"

/**
 * DTO ИИ-ассистента кабинета продавца (fd-assistant-01).
 *
 * Ассистент — чат, который знает контекст ЭТОГО магазина (оборот, заказы,
 * средний чек, возвраты, к выплате за 30 дней), базу знаний OSMIX (FAQ) и
 * правила площадки. Магазин резолвится из токена продавца в роуте — наружу
 * shopId параметром не принимается, продавец всегда общается только по своему
 * магазину.
 */

/** Реплика диалога: продавец ('user') или ассистент ('assistant'). */
export type AssistantRole = "user" | "assistant"

/** Сообщение истории диалога с ассистентом. */
export type AssistantMessage = {
  id: string
  role: AssistantRole
  content: string
  /** ISO-время создания реплики. */
  createdAt: string
}

/** Запрос продавца ассистенту. */
export type AssistantAskRequest = {
  /** Сообщение продавца. */
  message: string
}

/** Схема тела запроса `POST /seller/assistant/ask`. */
export const assistantAskSchema = z.object({
  message: z.string().min(1).max(2000),
})

/** Ответ ассистента на вопрос продавца. */
export type AssistantAnswer = {
  /** Текст ответа ассистента (по-русски, кратко). */
  answer: string
  /** id сохранённой реплики ассистента в истории. */
  messageId: string
  /**
   * Был ли ответ сгенерирован моделью. false — сработала мягкая деградация
   * (ключ OpenRouter не настроен или сбой), ответ отдан заглушкой.
   */
  aiUsed: boolean
}

/** Ответ `GET /seller/assistant/history`. */
export type AssistantHistory = {
  messages: AssistantMessage[]
}
